import { CSSObject } from '@chakra-ui/react';

export const DrawerHeaderContainer: CSSObject = {
  display: 'flex',
  justifyContent: 'space-between',
  zIndex: 'popover',
  bgGradient: 'linear(to-b, beta.300, beta.500)',
  alignItems: 'center',
  borderBottom: '2px solid',
  borderColor: 'alpha.300',
  h: '16',
};

export const IconCircleOutline: CSSObject = {
  boxSize: '8',
  color: 'alpha.300',
};
